import { UseMutationResult } from "@tanstack/react-query";
import { useCallback } from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { Icon } from "./Icon";

export interface MutationErrorIconProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mutation: UseMutationResult<any, Error, any>;
  className?: string;
}

/**
 * Component to render an error icon when the provided mutation is in an error state. Hovering the icon show the error
 * message, and clicking the icon resets the mutation state (i.e. clears the current error).
 */
export const MutationErrorIcon: React.FC<MutationErrorIconProps> = ({ mutation, className }) => {
  // Define a click handler to reset the mutation state (i.e. clear the current error)
  const handleClick = useCallback(() => {
    mutation.reset();
  }, [mutation]);

  // Display nothing if the mutation has no error
  if (!mutation.isError) return null;

  const tooltip = (
    <Tooltip style={{ "--bs-tooltip-max-width": "300px" }}>
      <span className="text-danger">ERROR: {mutation.error.message}</span>
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <Button variant="link" onClick={handleClick} disabled={mutation.isPending} className={className}>
        <Icon icon="exclamation-triangle" className="text-danger" />
      </Button>
    </OverlayTrigger>
  );
};
